export const getVideoThumb = (src: string): Promise<string> => {
	return new Promise((resolve) => {
		let video = document.createElement('video')
		let canvasElement = document.createElement('canvas')
		let context = canvasElement.getContext('2d')
		video.src = src
		video.onloadedmetadata = function () {
			const width = video.videoWidth
			const height = video.videoHeight
			canvasElement.width = width
			canvasElement.height = height
			context?.drawImage(video, 0, 0, width, height)
			const thumbnailDataUrl = canvasElement.toDataURL('image/png')
			resolve(thumbnailDataUrl)
		}
	})
}
export const extractSizeFromUrl = (url: string) => {
	if (!url) return null

	const path = url.split('?')[0].split('#')[0].trim()
	const match = path.match(/_(\d+)_(\d+)\.[^.\/]+$/)
	if (!match) return null

	const width = Number(match[1])
	const height = Number(match[2])
	if (!width || !height) return null

	return {
		width: String(width),
		height: String(height)
	}
}

/**
 * URL 参数解析函数
 * @param link URL 链接
 * @returns 参数对象
 */
export const getParamsByUrl = (link?: string): Record<string, string> => {
  if (!link) return {};
  const url = new URL(link);
  const params = new URLSearchParams(url.search);

  return searchParamsToObject(params);
};

const searchParamsToObject = (params: URLSearchParams): Record<string, string> => {
  const result: Record<string, string> = {};
  params.forEach((value, key) => {
    result[key] = value;
  });
  return result;
};

/**
 * 兼容低版本安卓的 URL 参数解析函数
 * 使用传统方式解析
 * @param link URL 链接
 * @returns 参数对象
 */
export const getParamsByUrlCompatible = (link?: string): Record<string, string> => {
	if (!link) return {}

	try {
		const urlObj = new URL(link)
		const search = urlObj.search
		if (!search) return {}

		const params: Record<string, string> = {}
		// 移除开头的 '?'，然后按 '&' 分割
		const pairs = search.slice(1).split('&')
		for (const pair of pairs) {
			const [key, value] = pair.split('=')
			if (key) {
				params[decodeURIComponent(key)] = value ? decodeURIComponent(value) : ''
			}
		}

		return params
	} catch {
		// 如果 URL 解析失败，尝试传统方式解析
		const questionMarkIndex = link.indexOf('?')
		if (questionMarkIndex === -1) return {}

		const search = link.slice(questionMarkIndex + 1)
		if (!search) return {}

		const params: Record<string, string> = {}
		const pairs = search.split('&')

		for (const pair of pairs) {
			const [key, value] = pair.split('=')
			if (key) {
				params[decodeURIComponent(key)] = value ? decodeURIComponent(value) : ''
			}
		}
		return params
	}
}
export const objectToUrlParams = (obj: any) => {
	const params = []
	for (let key in obj) {
		if (obj.hasOwnProperty(key)) {
			const value = encodeURIComponent(obj[key])
			params.push(`${encodeURIComponent(key)}=${value}`)
		}
	}
	return params.join('&')
}

/**
 * 根据地址获得数据的字节流并转换成大小
 * @param strUrl 网络连接地址
 * @return
 */
export const getFileSizeByUrl = (url: string) => {
	let fullUrl = window.location.origin + '/proxy/static?url=' + url
	console.log('fullUrl', fullUrl)
	return new Promise<string>((resolve, reject) => {
		let xhr = new XMLHttpRequest()
		xhr.open('HEAD', fullUrl, true)
		xhr.onreadystatechange = function () {
			if (xhr.readyState === 4) {
				if (xhr.status === 200) {
					let fileSize = xhr.getResponseHeader('Content-Length')
					console.log('文件大小', fileSize)
					resolve(fileSize || '')
				} else {
					reject(new Error('获取文件大小失败'))
				}
			}
		}
		xhr.send()
	})
}
/*
  移除URL参数
*/
export const removeUrlParam = (url: string, paramName: string): string => {
	const urlObj = new URL(url)
	urlObj.searchParams.delete(paramName)
	return urlObj.toString()
}

/**
 * 解析 daoke 协议的 URL
 * @param urlScheme daoke 协议字符串
 * @returns 解析后的参数对象
 */
export const parseDaokeUrl = (urlScheme: string): Record<string, string> | null => {
	if (!urlScheme?.startsWith('daoke://')) return null

	try {
		const url = new URL(urlScheme.replace('daoke://', 'http://'))
		const params = searchParamsToObject(url.searchParams);

		if (params.url) {
			const decodedUrl = decodeURIComponent(params.url)
			params.url = decodedUrl
			try {
				const nestedUrl = new URL(decodedUrl)
				params.pathname = nestedUrl.pathname
			} catch (e) {
				const pathMatch = decodedUrl.match(/^https?:\/\/[^\/]+(\/[^?#]*)/)
				if (pathMatch) {
					params.pathname = pathMatch[1]
				}
			}
		}

		return params
	} catch {
		return null
	}
}
